import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter, FaWhatsapp
} from 'react-icons/fa';
import {
  FiPhone, FiMail, FiMapPin, FiClock, FiSend, FiArrowRight
} from 'react-icons/fi';
import productsData from '../../data/products.json';

const quickLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/products', label: 'Our Products' },
  { to: '/distribution-network', label: 'Distribution Network' },
  { to: '/become-dealer', label: 'Become a Dealer' },
  { to: '/careers', label: 'Careers' },
  { to: '/contact', label: 'Contact Us' },
];

export default function Footer() {
  const { categories } = productsData;
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) { setSubscribed(true); setEmail(''); }
  };

  return (
    <footer className="main-footer">
      <div className="container">
        <div className="row g-5">

          {/* Brand Column */}
          <div className="col-lg-3 col-md-6">
            <div className="footer-brand">
              <div className="footer-logo">
                <div className="footer-logo-icon">AE</div>
                <div>
                  <div className="footer-logo-name">Avivan Enterprises</div>
                  <div className="footer-logo-tagline">FMCG Distribution Partner</div>
                </div>
              </div>
              <p className="footer-desc">
                Your trusted FMCG distribution partner delivering quality products across Tamil Nadu through a strong supply chain, authorized brand partnerships, and a growing dealer network.
              </p>

              {/* Certification Badges */}
              <div className="footer-cert-badges">
                <div className="fcb-item">
                  <span className="fcb-icon">✅</span>
                  <div>
                    <div className="fcb-label">FSSAI Certified</div>
                    <div className="fcb-num">Lic. No. 22725XXXXXXXXX</div>
                  </div>
                </div>
                <div className="fcb-item">
                  <span className="fcb-icon">📋</span>
                  <div>
                    <div className="fcb-label">GST Registered</div>
                    <div className="fcb-num">33XXXXXXXXXXX1Z5</div>
                  </div>
                </div>
              </div>

              <div className="footer-social">
                {[
                  { icon: <FaFacebookF />, href: '#', label: 'Facebook' },
                  { icon: <FaInstagram />, href: '#', label: 'Instagram' },
                  { icon: <FaLinkedinIn />, href: '#', label: 'LinkedIn' },
                  { icon: <FaWhatsapp />, href: 'https://wa.me/919876543210', label: 'WhatsApp' },
                  { icon: <FaTwitter />, href: '#', label: 'Twitter' },
                ].map(s => (
                  <a key={s.label} href={s.href} className="social-icon" title={s.label} aria-label={s.label}
                    target={s.href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer">
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <div className="footer-col">
              <h5>Quick Links</h5>
              <ul className="footer-links">
                {quickLinks.map(l => (
                  <li key={l.to}>
                    <Link to={l.to} className="footer-link">
                      <FiArrowRight size={12} /> {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Product Categories */}
          <div className="col-lg-2 col-md-6">
            <div className="footer-col">
              <h5>Our Categories</h5>
              <ul className="footer-links">
                {categories.map(c => (
                  <li key={c.id}>
                    <Link to="/products" className="footer-link">
                      <span style={{ marginRight: 6 }}>{c.emoji}</span>
                      {c.name}
                      {c.status === 'active' && (
                        <span style={{ marginLeft: 6, background: 'var(--secondary)', color: '#fff', fontSize: '0.55rem', padding: '1px 5px', borderRadius: 20, fontWeight: 700, verticalAlign: 'middle' }}>
                          LIVE
                        </span>
                      )}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-lg-2 col-md-6">
            <div className="footer-col">
              <h5>Contact</h5>
              <div className="footer-contact-item">
                <FiPhone className="fci-icon" />
                <div className="fci-text">
                  <a href="tel:+919876543210">+91 98765 43210</a><br />
                  <a href="tel:+919876543211">+91 98765 43211</a>
                </div>
              </div>
              <div className="footer-contact-item">
                <FiMail className="fci-icon" />
                <div className="fci-text">
                  <a href="mailto:info@avivanenterprises.com">info@avivanenterprises.com</a>
                </div>
              </div>
              <div className="footer-contact-item">
                <FiMapPin className="fci-icon" />
                <div className="fci-text">Tamil Nadu, India</div>
              </div>
              <div className="footer-contact-item">
                <FiClock className="fci-icon" />
                <div className="fci-text">Mon–Sat: 9AM – 6PM</div>
              </div>
              <a href="https://wa.me/919876543210?text=Hello%20Avivan%20Enterprises%2C%20I%20am%20interested%20in%20your%20FMCG%20distribution%20services."
                target="_blank" rel="noopener noreferrer"
                className="footer-whatsapp-btn">
                <FaWhatsapp size={14} /> Chat on WhatsApp
              </a>
            </div>
          </div>

          {/* Newsletter */}
          <div className="col-lg-3 col-md-6">
            <div className="footer-col">
              <h5>Newsletter</h5>
              <p style={{ fontSize: '0.83rem', color: 'rgba(255,255,255,0.5)', marginBottom: 16, lineHeight: 1.65 }}>
                Subscribe for updates on new products, dealer opportunities, and market insights.
              </p>
              {subscribed ? (
                <div style={{ background: 'rgba(40,167,69,0.15)', border: '1px solid var(--secondary)', color: 'var(--secondary)', padding: '12px 16px', borderRadius: 8, fontSize: '0.85rem', fontWeight: 600 }}>
                  ✓ Thank you for subscribing!
                </div>
              ) : (
                <form onSubmit={handleSubscribe} className="footer-newsletter">
                  <input
                    type="email"
                    placeholder="Your email address"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit" className="btn-primary-c w-100" style={{ justifyContent: 'center' }}>
                    <FiSend size={14} /> Subscribe
                  </button>
                </form>
              )}

              {/* Currently Distributing box */}
              <div className="footer-brand-box">
                <div className="fbb-label">Currently Distributing</div>
                <div className="fbb-brand">🌶️ Aachi Masala</div>
                <div className="fbb-sub">Official Authorized Distributor</div>
                <div className="fbb-divider" />
                <div className="fbb-label" style={{ marginTop: 8 }}>Expanding Soon</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 6 }}>
                  {['🍫', '🌾', '🍎', '🥦', '🛒'].map(e => (
                    <span key={e} style={{ fontSize: '1rem' }}>{e}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom" style={{ marginTop: 60 }}>
        <div className="container">
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
            <p className="footer-bottom-text mb-0">
              © 2026 Avivan Enterprises. All Rights Reserved. | FMCG Distribution &amp; Supply Chain, Tamil Nadu, India
            </p>
            <div className="footer-bottom-links">
              <a href="#!" className="footer-bottom-link">Privacy Policy</a>
              <a href="#!" className="footer-bottom-link">Terms of Service</a>
              <a href="#!" className="footer-bottom-link">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
